import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder } from '../test-utils';
import { createInsightsApi } from './';
export var createInsightsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createInsightsApi('', fakeHttp);
    var baseUrl = '/analytics';
    var pageSize = 200; //magic number
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetTopIssues: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/topIssues')(dto);
        },
        whenGetTopIssuesByCategories: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/topIssues/categories')(dto);
        },
        whenGetTopIssueOverview: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/article/' + dto.articleId)(dto);
        },
        whenGetTicketStatsOverview: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/tickets/stats')(dto);
        },
        whenGetTicketStatsHistogram: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/tickets/stats/histogram')(__assign(__assign({}, dto), { pageSize: pageSize }));
        },
        whenGetTicketInsights: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/tickets/insights')(dto);
        },
        whenGetAgentsTicketsPerformance: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/tickets/performance/agents')(dto);
        },
        whenGetAgentTicketsPerformance: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + ("/tickets/performance/agents/" + dto.id))(dto);
        },
        whenGetAgentTicketsHistogram: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + ("/tickets/performance/agents/" + dto.userId + "/histogram"))(__assign(__assign({}, dto), { pageSize: pageSize }));
        },
        whenGetGroupTicketsPerformance: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + ("/tickets/performance/groups/" + dto.id))(dto);
        },
        whenGetGroupTicketsHistogram: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + ("/tickets/performance/groups/" + dto.groupId + "/histogram"))(__assign(__assign({}, dto), { pageSize: pageSize }));
        },
        whenGetGroupsTicketsPerformance: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/tickets/performance/groups')(dto);
        },
        whenGetKbStatsOverview: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/overview')(dto);
        },
        whenGetKbStatsHistogram: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/overview/histogram')(__assign(__assign({}, dto), { pageSize: pageSize }));
        },
        whenGetMostReadArticles: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/article/mostRead')(dto);
        },
        whenGetMostHelpfulArticles: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/article/mostHelpful')(dto);
        },
        whenGetTopFeatureRequests: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/article/topFeatureRequests')(dto);
        },
        whenGetTopKnownIssues: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/article/topKnownIssues')(dto);
        },
        whenGetTopSearchTerms: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/search/popular')(dto);
        },
        whenGetTopUnansweredSearchTerms: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/search/mostUnanswered')(dto);
        },
        whenGetExtendedSearchTerm: function (dto) {
            return createFakePostResponder(fakeHttp, baseUrl + '/search/extended')(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=teskit.js.map